




import vue from "vue";
import { VUEX_EXERCISE_GETTER_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

import ExerciseScopeFooter from "@tt-app/components/exercise/consolidated/exercise/footer/ExerciseScopeFooter.vue";
import ReviewFooter from "@tt-app/components/exercise/consolidated/exercise/footer/ReviewFooter.vue";
import WritingFooter from "@tt-app/components/exercise/consolidated/exercise/footer/WritingFooter.vue";

const { BODY, EXERCISE_TYPE, PAGE_TYPE } = VUEX_EXERCISE_GETTER_NAMES;
const { LOADING, PROCESSING } = VUEX_EXERCISE_GETTER_NAMES;

interface Computed {
  derivedComponent: string;
  disabled: boolean;
  exerciseType: string;
  loading: number;
  pageBody: any[];
  pageType: string;
  processing: number;
}

export default vue.extend<any, any, Computed, any>({
  name: "ExerciseFooter",

  components: { ExerciseScopeFooter, ReviewFooter, WritingFooter },

  computed: {
    derivedComponent() {
      if (!this.pageBody || !this.exerciseType) return "";

      const pageType = this.pageType;

      switch (pageType) {
        case "EXERCISE_SCOPE":
          return "exercise-scope-footer";
        case "WRITING":
          return "writing-footer";
        case "REVIEW":
          return "review-footer";
        default:
          return "";
      }
    },

    disabled() {
      return Boolean(this.loading || this.processing);
    },

    exerciseType() {
      const exerciseType = this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_TYPE}`];

      switch (exerciseType) {
        case 13:
          return "WRITING";
        default:
          return "";
      }
    },

    loading() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${LOADING}`];
    },

    pageBody() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${BODY}`];
    },

    pageType() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${PAGE_TYPE}`];
    },

    processing() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${PROCESSING}`];
    }
  }
});
